<div class="artist-overlay-panel d-flex justify-content-center">
  <!-- Main content wrapper with dynamic dimmed background and max-width -->
  <div [class.dimmed-background]="visible" class="w-100 mw-100 mx-auto" style="max-width: 1200px;">
    <!-- Overlay component with responsive behavior and close event handling -->
    <p-overlay [(visible)]="visible" (onHide)="onClose($event)"
      [responsive]="{ breakpoint: '640px', direction: 'bottom', contentStyleClass: 'h-20rem' }">
      <!-- Overlay content with styling and close button -->
      <div class="bg-white p-4 m-0 shadow-lg border-0 rounded-xl position-relative">
        <!-- Close button icon -->
        <i class="pi pi-times close-btn-custom position-absolute cursor-pointer" (click)="onClose($event)"
        style="top: 16px; right: 16px; z-index: 10;"></i>

        <!-- Main overlay content container -->
        <div class="overlay-container">

          <!-- Top Section: Split into Personal and Business Information -->
          <div class="row g-2">
            <!-- Personal Information Section -->
            <div class="col-lg-6">
              <!-- Personal info card with flexible layout -->
              <div class="info-section bg-light rounded-2 p-4 h-100 d-flex flex-column">
                <!-- Section title with icon -->
                <h3 class="section-title d-flex align-items-center gap-3 mb-4 pb-2 border-bottom">
                  <i class="pi pi-user"></i>
                  {{ 'artistOverlay.personalInformation' | transloco }}
                </h3>
                <!-- Personal info layout with image and details -->
                <div class="row g-2">
                  <!-- Profile image -->
                  <div class="col-lg-4">
                    <div class="profile-img-container">
                      <img [src]="artist.ImgUrl" [alt]="'artistOverlay.artistImageAlt' | transloco: { name: artist.Name }" class="profile-img rounded-3"
                        [routerLink]="['/profile', artist.Id]">
                      </div>
                    </div>
                    <!-- Personal details card -->
                    <div class="col-lg-8">
                      <div class="info-card bg-white rounded-2 p-4 h-100 d-flex flex-column">
                        <div class="info-content flex-grow-1">
                          <!-- Artist name -->
                          <h2 class="info-name mb-3">{{ artist.Name }}</h2>
                          <!-- Contact information -->
                          <div class="contact-info mb-3">
                            <!-- Email display -->
                            @if (artist.Email) {
                              <div class="contact-item d-flex align-items-center gap-2 mb-2">
                                <i class="pi pi-envelope"></i>
                                <span>{{ artist.Email }}</span>
                              </div>
                            }
                            <!-- Mobile number display -->
                            @if (artist.MobileNumber) {
                              <div class="contact-item d-flex align-items-center gap-2 ">
                                <i class="pi pi-phone"></i>
                                <span>{{ artist.MobileNumber }}</span>
                              </div>
                            }
                          </div>
                          <!-- Social media links -->
                          <div class="social-links d-flex gap-2 mb-3">
                            <!-- Facebook link -->
                            @if (artist.FacebookLink) {
                              <a [href]="artist.FacebookLink" target="_blank"
                                class="social-btn social-facebook">
                                <i class="pi pi-facebook"></i>
                              </a>
                            }
                            <!-- Instagram link -->
                            @if (artist.InstagramLink) {
                              <a [href]="artist.InstagramLink" target="_blank"
                                class="social-btn social-instagram">
                                <i class="pi pi-instagram"></i>
                              </a>
                            }
                            <!-- LinkedIn link -->
                            @if (artist.LinkedinLink) {
                              <a [href]="artist.LinkedinLink" target="_blank"
                                class="social-btn social-linkedin">
                                <i class="pi pi-linkedin"></i>
                              </a>
                            }
                          </div>
                          <!-- About me section -->
                          @if (artist.AboutMe) {
                            <div class="about-section mb-2">
                              <h4 class="about-title mb-2">{{ 'artistOverlay.aboutMe' | transloco }}</h4>
                              <div class="about-content rounded-2 p-3" [innerHTML]="artist.AboutMe"></div>
                            </div>
                          }
                          <!-- Address display -->
                          @if (artist.AddressLine1) {
                            <div class="address-info d-flex align-items-center gap-2 mt-auto">
                              <i class="pi pi-map-marker"></i>
                              <span>{{artist.AddressLine1}}</span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Business Information Section -->
              <div class="col-lg-6">
                <!-- Business info card with flexible layout -->
                <div class="info-section bg-light rounded-2 p-4 h-100 d-flex flex-column">
                  <!-- Section title with icon -->
                  <h3 class="section-title d-flex align-items-center gap-3 mb-4 pb-2 border-bottom">
                    <i class="pi pi-building"></i>
                    {{ 'artistOverlay.businessInformation' | transloco }}
                  </h3>
                  <!-- Business info layout with logo and details -->
                  <div class="row g-2">
                    <!-- Business logo -->
                    <div class="col-lg-4">
                      <div class="profile-img-container">
                        <img [src]="artist.BusinessLogoUrl" [alt]="'artistOverlay.businessLogoAlt' | transloco: { name: artist.BusinessName }"
                          class="profile-img rounded-3">
                        </div>
                      </div>
                      <!-- Business details card -->
                      <div class="col-lg-8">
                        <div class="info-card bg-white rounded-2 p-4 h-100 d-flex flex-column">
                          <div class="info-content flex-grow-1">
                            <!-- Business name -->
                            <h4 class="info-name mb-2">{{ artist.BusinessName }}</h4>
                            <!-- Business details -->
                            <div class="info-details mb-2">
                              <!-- Business phone number -->
                              @if (artist.BusinessNumber) {
                                <div class="detail-item d-flex align-items-center gap-2 mb-2">
                                  <i class="pi pi-phone"></i>
                                  <span>{{artist.BusinessNumber}}</span>
                                </div>
                              }
                              <!-- ABN display -->
                              @if (artist.ABN) {
                                <div class="detail-item d-flex align-items-center gap-2 mb-2">
                                  <i class="pi pi-id-card"></i>
                                  <span>{{artist.ABN}}</span>
                                </div>
                              }
                            </div>
                            <!-- Business social media links -->
                            <div class="social-links d-flex gap-2 mb-3">
                              <!-- Business Facebook link -->
                              @if (artist.BusinessFacebookLink) {
                                <a [href]="artist.BusinessFacebookLink" target="_blank"
                                  class="social-btn social-facebook">
                                  <i class="pi pi-facebook"></i>
                                </a>
                              }
                              <!-- Business Instagram link -->
                              @if (artist.BusinessInstagramLink) {
                                <a [href]="artist.BusinessInstagramLink" target="_blank"
                                  class="social-btn social-instagram">
                                  <i class="pi pi-instagram"></i>
                                </a>
                              }
                              <!-- Business LinkedIn link -->
                              @if (artist.BusinessLinkedinLink) {
                                <a [href]="artist.BusinessLinkedinLink" target="_blank"
                                  class="social-btn social-linkedin">
                                  <i class="pi pi-linkedin"></i>
                                </a>
                              }
                            </div>
                            <!-- Business address display -->
                            @if (artist.StreetAddress) {
                              <div class="address-info d-flex align-items-center gap-2 mt-auto">
                                <i class="pi pi-map-marker"></i>
                                <span>{{artist.StreetAddress}}</span>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Bottom Section: Analytics Data -->
              <div class="bottom-section">
                <div class="row g-2 mb-3">
                  <!-- Recent Consignments Card -->
                  <div class="col-lg-6">
                    <!-- Consignments data card -->
                    <div class="data-card analytics-card rounded-3 border shadow-sm h-100 d-flex flex-column">
                      <!-- Card header with icon and title -->
                      <div class="data-card-header bg-light p-3 d-flex align-items-center gap-3 border-bottom">
                        <i class="pi pi-list"></i>
                        <h3 class="mb-0 fs-5 fw-semibold">{{ 'artistOverlay.recentConsignments' | transloco }}</h3>
                      </div>
                      <!-- Card body with consignment list -->
                      <div class="data-card-body bg-white p-3 flex-grow-1">
                        <!-- Consignment list display -->
                        @if (dashboardData.RecentConsignments && dashboardData.RecentConsignments.length > 0) {
                          <div class="consignment-list"
                            >
                            <!-- Individual consignment item -->
                            @for (product of dashboardData.RecentConsignments | slice:0:5; track product) {
                              <div class="consignment-item mb-3"
                                >
                                <div class="consignment-info d-flex justify-content-between align-items-center">
                                  <span class="consignment-name">{{ product.Name }}</span>
                                  <!-- Consignment product count -->
                                  <span class="consignment-items text-center">
                                    <span class="data-badge circular-badge bg-select">
                                      {{ product.NumberOfConsignmentProducts }}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <!-- Empty state for no consignments -->
                        @if (!dashboardData.RecentConsignments || dashboardData.RecentConsignments.length === 0) {
                          <div class="empty-state"
                            >
                            <i class="pi pi-info-circle"></i>
                            <span>{{ 'artistOverlay.noConsignmentsFound' | transloco }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                  <!-- Top Selling Series Card -->
                  <div class="col-lg-6">
                    <!-- Top selling series data card -->
                    <div class="data-card analytics-card rounded-3 border shadow-sm h-100 d-flex flex-column">
                      <!-- Card header with icon and title -->
                      <div class="data-card-header bg-light p-3 d-flex align-items-center gap-3 border-bottom">
                        <i class="pi pi-chart-bar"></i>
                        <h3 class="mb-0 fs-5 fw-semibold">{{ 'artistOverlay.topSellingSeries' | transloco }}</h3>
                      </div>
                      <!-- Card body with progress bars -->
                      <div class="data-card-body bg-white p-3 flex-grow-1">
                        <!-- Progress list for top selling series -->
                        @if (dashboardData.ArtistBestSellingSeries && dashboardData.ArtistBestSellingSeries.length > 0) {
                          <div class="progress-list"
                            >
                            <!-- Individual progress item -->
                            @for (item of dashboardData.ArtistBestSellingSeries; track item) {
                              <div class="progress-item mb-3">
                                <div class="progress-info d-flex justify-content-between align-items-center">
                                  <span class="series-name">{{ item.SeriesName }}</span>
                                  <span class="series-percentage" [innerHTML]="item.TextBasedOnPercentage"></span>
                                </div>
                                <!-- Progress bar with dynamic styling -->
                        <div class="progress-bar-container" [ngClass]="{
                               'bg-zero': item.PercentageOfTotal === 0,
                               'bg-full': item.PercentageOfTotal === 100,
                               'bg-unselect': item.PercentageOfTotal > 0 && item.PercentageOfTotal < 100
                             }">
                                  <div class="progress-bar bg-select" [style.width.%]="item.PercentageOfTotal">
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <!-- Empty state for no records -->
                        @if (!dashboardData.ArtistBestSellingSeries || dashboardData.ArtistBestSellingSeries.length === 0) {
                          <div class="empty-state"
                            >
                            <i class="pi pi-info-circle"></i>
                            <span>{{ 'artistOverlay.noRecordsFound' | transloco }}</span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Sales Insights Section -->
                @if (dashboardDataLoaded && showSalesHistory) {
                  <div class="data-card rounded-3 border shadow-sm mb-3">
                    <!-- Card header with icon and title -->
                    <div class="data-card-header bg-light p-3 d-flex align-items-center gap-3 border-bottom">
                      <i class="pi pi-chart-line"></i>
                      <h3 class="mb-0 fs-5 fw-semibold">{{ 'artistOverlay.salesInsights' | transloco }}</h3>
                    </div>
                    <!-- Card body with tabbed insights -->
                    <div class="data-card-body bg-white p-3">
                      <!-- Tab view for sales insights -->
                      @if (dashboardDataLoaded) {
                        <p-tabView [(activeIndex)]="selectedTabIndex" class="insights-tabs">
                          <!-- Dynamic tabs for each series -->
                          @for (item of dashboardData.ArtistInsightsSeriesData; track item) {
                            <p-tabPanel [header]="item.SeriesName">
                              <!-- Chart container for insights -->
                              <div class="insight-chart-container">
                                <artist-insights-chart [insightsSeriesData]="item"></artist-insights-chart>
                              </div>
                            </p-tabPanel>
                          }
                        </p-tabView>
                      }
                    </div>
                  </div>
                }

                <!-- High Performing Artworks Section -->
                <div class="data-card rounded-3 border shadow-sm">
                  <!-- Card header with title and sort selector -->
                  <div
                    class="data-card-header bg-light p-3 d-flex justify-content-between align-items-center border-bottom">
                    <div class="d-flex align-items-center gap-3">
                      <i class="pi pi-star-fill"></i>
                      <h3 class="mb-0 fs-5 fw-semibold">{{ 'artistOverlay.highPerformingArtworks' | transloco }}</h3>
                    </div>
                    <!-- Sort selector for artworks -->
                    <p-selectButton [options]="highPerformArtworksSortOptions"
                      [(ngModel)]="selectedHighPerformArtworksSortOption" [multiple]="false"
                      (onChange)="onHighPerformArtworksSortOptionSelected($event)" class="sort-selector">
                    </p-selectButton>
                  </div>
                  <!-- Card body with artwork tiles -->
                  <div class="data-card-body bg-white p-3">
                    <!-- Responsive grid for artwork tiles -->
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3">
                      <!-- Individual artwork tile -->
                      @for (product of dashboardData.HighPerformingArtworksBySalesValue; track product) {
                        <div
                          class="col artwork-item">
                          <artist-product-tile [product]="product"></artist-product-tile>
                        </div>
                      }
                      <!-- Empty state for no artworks -->
                      @if (!dashboardData.HighPerformingArtworksBySalesValue || dashboardData.HighPerformingArtworksBySalesValue.length == 0) {
                        <div class="empty-state w-100"
                          >
                          <i class="pi pi-image"></i>
                          <span>{{ 'artistOverlay.noProductsFound' | transloco }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-overlay>
      </div>
    </div>